import React from 'react'
// import useStyles from './ReportsModalContainer.styles'
import {useModalsStateContext} from 'modules/reports/contexts/modals/ModalsContext'

function ReportsModalContextProvider() {
  // const classes = useStyles()

  const {modal} = useModalsStateContext()
  if (!modal) return null

  const ModalC = modal.component
  return <ModalC {...modal.props} />
}

export default ReportsModalContextProvider
